module.exports = __webpack_public_path__ + "static/img/7-3.1d23a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/7-3.png
// module id = 5Qce
// module chunks = 25